<div style="width: 100%; max-width: 800px; margin: auto;">

  <mat-card style="text-align: center;">
    <img style='width: 200px; margin: 20px auto 20px auto;' src='assets/images/geral/selo_sbccv.png'>
  </mat-card>

  <mat-card>
    <div *ngIf="invite" style= 'text-align: center; font-size: 1.2em; font-weight: bold; color: rgb(0,0,0,.6);'>
      {{invite.event_name}}
    </div>
  </mat-card>

  <div *ngIf='readyToShow'>

    <div *ngIf='!dataUpdated'>

      <mat-card *ngIf="redirect">
        <div style='width: 100%; max-width: 500px; margin: auto;'>
          <p>
            <b>
              {{show_name}}
            </b>
          </p>
          <p>
            Por favor, aproveite para revisar seu mini currículo e atualizar sua foto,<br>
            caso julgue necessário.
          </p>
          <p>
            Obrigado.
          </p>
        </div>
      </mat-card>

      <mat-card>
        <div style='width: 100%; max-width: 500px; margin: auto;'>

            <div style='width: 100%; max-width: 600px; margin: auto;'>
              <p>Estes dados estão corretos?</p>
              <div style="padding: 3px 0 3px 0">
                Nome: {{show_name}}
              </div>
              <div style="padding: 3px 0 3px 0">
                Email: {{show_email}}
              </div>
              <div style="padding: 3px 0 3px 0">
                Celular: {{show_cellPhone}}
              </div>
              <div style="padding: 3px 0 3px 0">
                CPF: {{show_cpf}}
              </div>
              <p> Se não, por favor, anote os dados corretos no campo abaixo: </p>
            </div>
    
            <div style='width: 100%; max-width: 600px; margin: auto;'>
              <textarea
                style='font-size: 1.2em; width: 100%; height:60px; margin-top:10px; padding:5px; border-color: silver;'
                matInput [formControl]="entityForm.controls.comments" placeholder="Comentários" autocomplete="off">
                </textarea>
            </div>

            
        </div>
      </mat-card>

      <mat-card>

        <div class="post-image">
          <img [src]="_memberTempService.storedImage" *ngIf="_memberTempService.storedImage">
        </div>

        <div class='img-input'>

          <input #file type="file" accept='image/*' style='display:none;'
            (change)="_memberTempService.previewImage($event)" />

          <button mat-raised-button (click)='file.click()' >
            <mat-icon>image_search</mat-icon>
          </button>

        </div>

      </mat-card>

      <mat-card>
        <div style='width: 100%; max-width: 600px; margin:auto'>
          <ckeditor [config]="{ 
          toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>
        </div>
      </mat-card>

      <mat-card>
        <div class="actions" fxLayoutAlign="center" flex justify-content='center'>
          <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
          <button mat-raised-button (click)='updateChanges()' [disabled]="entityForm.invalid">
            <span style='color:green;'>
              Alterar dados
            </span>
          </button>
          <button mat-raised-button (click)='byPassUpdateChanges()' [disabled]="entityForm.invalid">
            <span style='color:green;'>
              Está correto
            </span>
          </button>
        </div>
      </mat-card>

      <br>
      <br>

    </div>

  </div>

</div>